class ContactPage extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    if (!this.form) return;

    this.inputs = this.form.querySelectorAll('input:not([type="submit"]):not([type="hidden"]), textarea');
    this.formLinks = this.querySelectorAll('form-subject');
    this.captureDataBtn = this.querySelector('capture-form');

    this.attachEvents();
  }

  attachEvents() {
    if (this.formLinks.length) {
      this.formLinks.forEach((formLink) => {
        formLink.addEventListener('click', this.onFormLinkClick.bind(this));
      });
    }

    if (this.captureDataBtn) {
      const button = this.captureDataBtn.querySelector('button');
      if (button) {
        button.addEventListener('click', this.onCaptureData.bind(this));
      }
    }

    if (this.inputs.length) {
      this.inputs.forEach((input) => {
        input.addEventListener('input', this.onInput.bind(this));
      });
    }
  }

  onInput(event) {
    const helperFormatPhoneNumber = function (phoneNumber) {
      const areaCode = phoneNumber.substring(1, 4);
      const firstPart = phoneNumber.substring(4, 7);
      const secondPart = phoneNumber.substring(7, 11);

      let formatted = '+1 ';

      formatted += areaCode ? `(${areaCode}) ` : '';
      formatted += firstPart ? firstPart : '';
      formatted += secondPart ? `-${secondPart}` : '';

      return formatted;
    };

    const helperButtonControl = function (requiredInputsLength) {
      const validInputsLength = this.form.querySelectorAll('[required][data-valid="true"]').length;
      const button = this.form.querySelector('button, input[type="submit"]');

      if (button && validInputsLength === requiredInputsLength) {
        button.removeAttribute('disabled');
      } else if (button) {
        button.setAttribute('disabled', '');
      }
    }.bind(this);

    const allRequiredInputs = this.form.querySelectorAll('input[required], textarea[required]');

    if (event.target.type === 'text' || event.target.type == 'textarea') {
      event.target.value = event.target.value.replace(/[^a-zA-Z0-9' -]/g, '');
      event.target.dataset.valid = event.target.value !== '';
    }

    if (event.target.type === 'tel') {
      let phoneNumber = event.target.value.replace(/\D/g, '');

      if (phoneNumber.length > 0) {
        phoneNumber = phoneNumber.charAt(0) !== '1' ? '1' + phoneNumber : phoneNumber;
        phoneNumber = phoneNumber.slice(0, 11);

        event.target.dataset.valid = phoneNumber.length === 11;

        if (event.inputType !== 'deleteContentBackward') {
          phoneNumber = phoneNumber.length > 1 ? helperFormatPhoneNumber(phoneNumber) : '+1';
        }
      }

      event.target.value = phoneNumber;
    }

    if (event.target.type === 'email') {
      const domainRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (event.target.checkValidity() && domainRegex.test(event.target.value)) {
        event.target.dataset.valid = true;
      } else {
        event.target.dataset.valid = false;
      }
    }

    helperButtonControl(allRequiredInputs.length);
  }

  onFormLinkClick(event) {
    const parent = event.target.closest('[data-form-hidden]');
    if (!parent) return;

    const form = parent.querySelector('form');
    if (!form) return;

    const currentValue = event.target.dataset.target;
    const formSelectOptions = form.querySelectorAll('select > option');

    parent.dataset.formHidden = parent.dataset.formHidden === 'true' ? 'false' : parent.dataset.formHidden;

    for (const option of formSelectOptions) {
      if (option.value === currentValue) {
        option.selected = true;
        break;
      }
    }
  }

  async onCaptureData(event) {
    event.preventDefault();

    const formData = {};
    const telWarningText = this.form.querySelector('.tel__warning-text');
    const successMessage = this.querySelector('success-message');

    if (!this.inputs.length) return;

    this.inputs.forEach((input) => {
      const key = input.name.replace('contact[', '').replace(']', '');
      const value = input.value;
      formData[key] = this.sanitize(value);
    });

    if (formData.phone_number) {
      const KLdata = {
        type: 'profile',
        attributes: formData,
      };

      const KLoptions = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          revision: '2024-02-15',
        },
        body: JSON.stringify({ data: KLdata }),
      };

      try {
        const response = await fetch('https://a.klaviyo.com/client/profiles/?company_id=SQEMbF', KLoptions);

        if (response.ok) {
          if (this.form) this.form.style.display = 'none';
          if (successMessage) successMessage.style.display = 'block';
          if (telWarningText) telWarningText.style.display = 'none';
        } else {
          if (telWarningText) telWarningText.style.display = 'inline-block';
        }
      } catch (error) {
        console.error('Fetch error:', error);
        if (telWarningText) {
          telWarningText.style.display = 'inline-block';
        }
      }
    }
  }

  sanitize(value) {
    return value.replace(/[&<>"'/]/g, function (char) {
      const chars = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;', '/': '&#x2F;' };

      return chars[char];
    });
  }
}

customElements.define('main-contact', ContactPage);
